/**
 * 状态类：status { success、error、warn }
 * 弹窗类：dialog { toast、alert、confirm }
 * 表单类：from { placeholder、label }
 * 表格类：table { }
 *
 * 接口请求类：request
 * 接口响应类：responce
 *
 * 页面模块类：
 *
 */

// 使用 {{$t("purchase.periods")}}  //Periode ke-*

// 状态
const state = {
  preheatIng: "Pemanasan",
  purchaseIng: "Sedang Dibeli",
  process: "Sedang Bantu",
  over: "Telah Berakhir",
  finish: "Telah Selesai",
  noData: "Belum Ada Data",
};

//抢购区和个人抢购记录页上方的subheader
const subheader = {
  pricePromise: "Jaminan Harga, Tidak Akan Jatuh",
  vipPrice: "Rebate VIP, Harga Diskon",
  protection: "Perlindungan Harga Eksklusif Berbasis Fiat",
  pricePromiseVal: "Jaminan Harga [*] Hari, Tidak Akan Jatuh",
  rewards: "Pendapatan [*]%, Janji Jaminan Harga",
  vipDis: "Diskon VIP, Beli dan Untung",
  zlz: "Sedang Bantu",
};

// 抢购区
const purchase = {
  periods: "Periode ke-[*]",
  timesSheaves: "Putaran ke-[*]",
  supportPic: "Jaminan Harga [*] Hari, Tidak Akan Jatuh",
  earnings: "Pendapatan [*]%, Janji Jaminan Harga",
  vipDiscount: "Diskon VIP, Beli dan Untung",
  limit: "Kuota Putaran Ini",
  timeLimit: "Harga Waktu Terbatas",
  schedule: "Progress Saat Ini",
  finishHalf: "Telah Selesai [*]%",
  subscriptionNum: "Jumlah Pembelian",
  vipText: "(VIP[*]) Nikmati diskon pembelian ([**] [***] [****] off)", //（VIP6）享购买（2000COINS 5折）优惠
  supportType: "Metode Jaminan Harga: Selama periode jaminan harga, BiKing akan memasukkan order beli di pasar sekunder dengan harga jaminan terendah. Pengguna dapat memilih untuk menjual selama periode jaminan harga atau tidak. Setelah periode jaminan harga berakhir, order beli jaminan harga terendah terkait akan dibatalkan.",
  beAbouttoAlipay: "Segera Mulai",
  atOnceAlipay: "Beli Sekarang",
  atOnceAlipayNew: "Bantu Sekarang",
  atOnceAlipayed: "Anda telah membeli, silakan perhatikan putaran berikutnya",
  atOnceAlipayedOver: "Anda telah membeli, tidak dapat membeli lagi",
  atOnceAlipayedNew: "Anda telah membantu, silakan perhatikan putaran berikutnya",
  atOnceAlipayedNewOver: "Anda telah membantu, tidak dapat berpartisipasi lagi",
  website: "Situs Web",
  whitePaper: "Whitepaper",
  foreshow: "Prakiraan Pembelian",
  startToUp: "Mulai Beli",
  startToUpNew: "Mulai Bantu",
  distanceStartToUp: "Menuju Mulai Beli",
  num: "Saat ini telah ([*]) orang berhasil membeli ([**] BAT)",
  bannerText: "[*] berhasil membeli kuota [**]",
  bannerTextNew: "[*] membantu kuota [**]",
  nextProject: "Kuota Anda telah habis, silakan perhatikan proyek berikutnya",
  timesText: "Putaran ini telah habis, putaran berikutnya akan mulai tepat pada [*]月[**]日 [***]:[****]:[*****]",
  times: "[*] Hari [**] Jam [***] Menit [****] Detik",
  viewDetail: "Lihat Detail",
  completePawd: "Selesaikan Pengaturan Kata Sandi Transaksi Akun",
  sureCoins: "Pastikan holding lebih dari [*] [**] (jumlah pembelian minimum)",
  sureBalance: "Pastikan saldo [*] di akun lebih dari [**]",
  set: "Atur",
  available: "Kuota yang Dapat Dibeli",
  holding: "Holding Akun",
  startSoon: "Pembelian Segera Dimulai",
  startSoonNew: "Bantuan Segera Dimulai",
  projectSupp: "Kuota Proyek",
  projectSuppNew: "Batas Bantuan",
  successBuy: "Berhasil Membeli",
  successBuyNew: "Berhasil Membantu",
  projectLimit: "Sisa waktu menuju mulai proyek",
  subscription: "Telah Berhasil Membeli",
  subscriptionNew: "Telah Berhasil Membantu",
  projectGoal: "Total Kuota Pembelian Proyek Ini",
  projectGoalNew: "Kuota Bantuan Proyek Ini",
  goalFunds: "Saat Ini Telah Selesai Dibeli",
  goalFundsNew: "Bantuan Aktual Mencapai Target",
};

//抢购条件

const purchaseCondition = {
  q: " dan ",
  h: " atau ",
  cztj: "Pastikan Jumlah Isi Ulang",
  wqyh: "Terbatas untuk pengguna yang belum berpartisipasi dalam aktivitas terkait sebelumnya",
  vipdj: "Terbatas untuk pengguna level VIP[*] dan di atasnya",
  condition: "Syarat Pembelian",
  conditionNew: "Syarat Bantuan",
  nameverify1: "Selesaikan Verifikasi KYC Tiongkok Daratan",
  nameverify2: "Selesaikan Verifikasi KYC di Luar Tiongkok Daratan",
  nameverify3: "Selesaikan Verifikasi KYC BiKing",
  login: "Silakan Login",
  maxBuyin: "Pembelian Maksimum",
  verify: "Verifikasi KYC",
  affirm: "Pastikan holding lebih dari [*]",
  myPosition: "Holding Saya",
  AmountOfAscension: "Kuota Pembelian",
  AmountOfAscensionNew: "Kuota Bantuan",
  AmountOfAscensionText: "Semakin besar rata-rata holding [*] harian 7 hari sebelum putaran pertama dimulai, semakin besar kuota pembelian Anda",
  AmountOfAscensionTime: "Rata-rata Holding [*] Harian 7 Hari Saya",
  discount: "Diskon Pembelian",
  vip_discount: "Diskon Bantuan",
  discountText: "Semakin tinggi level VIP, semakin rendah harga pembelian",
  upgrade: "Upgrade",
  vipUpgrade: "VIP Saya",
  zled: "Kuota Bantuan",
  wdzl: "Bantuan Saya",
  zlxm: "Proyek Bantuan",
  mlzl: "Bantuan Per Putaran",
  zlmx: "Detail Bantuan",
  ccff: "Distribusi Awal",
  qgmx: "Detail Pembelian",

  fjtj: "Syarat Tambahan",
  guoji: "Kewarganegaraan",
  noJoin: "Tidak Mendukung Partisipasi",
  wancheng: "Selesai",
  pinggu: "《Formulir Penilaian Risiko Investasi Mata Uang Digital》",
  cyhd: "Ikut Aktivitas",
};

// 历史项目
const historyProject = {
  rushLimit: "Kuota Pembelian",
  averagePic: "Harga Rata-rata",
  averageNum: "Jumlah Pembeli",
};

// 支付
const alipay = {
  alipaynum: "Jumlah Pembelian",
  alipaynumNew: "Kuota Bantuan",
  ShouldPay: "Harus Dibayar",
  VipDiscounts: "Diskon VIP",
  VipWin: "Diskon Member Win",
  willOpen: "Segera Dibuka",
  actualPayment: "Pembayaran Aktual",
  actualPaymentNew: "Bantuan Putaran Ini",
  importPassword: "Masukkan Kata Sandi Transaksi",
  forGetPassword: "Lupa Kata Sandi Transaksi?",
  promptlyAlipay: "Bayar Sekarang",
  purchaseSuccess: "Selamat, Pembelian Berhasil",
  purchaseSuccessNew: "Selamat, Bantuan Berhasil",
  purchaseError: "Maaf, Pembelian Gagal, silakan refresh halaman dan coba lagi",
};
// 项目详情
const projectDetails = {
  text: "Pastikan holding melebihi [*][**]",
  timelimitPic: "Harga Waktu Terbatas",
  subscriptionLimit: "Kuota Pembelian",
  subscriptionLimitNew: "Kuota Bantuan",
  preheat: "Pemanasan",
  supportAbort: "Batas Waktu Jaminan Harga",
  unlockAbort: "Waktu Distribusi",
  projectIntroduction: "Pengenalan Proyek",
  projectRole: "Aturan Aktivitas",
  rule: "Aturan Pembelian",
  ruleNew: "Aturan Bantuan",
};
// 抢购结束
const purchaseOver = {
  haveSubscribed: "Kuota Telah Dibeli",
  schedule: "Progress Saat Ini",
  Stime: "Waktu Mulai Pembelian",
  StimeNew: "Waktu Mulai Bantuan",
  Etime: "Waktu Berakhir Pembelian",
  EtimeNew: "Waktu Berakhir Bantuan",
  successText: "Kuota penggalangan dana proyek ini [*] BAT, penggalangan dana aktual mencapai target penggalangan dana, penggalangan dana berhasil!",
  success: "Berhasil",
};
// 我的抢购
const myPurchase = {
  endUnlock: "Dibuka setelah putaran pembelian terakhir berakhir",
  endUnlock2: "Didistribusikan setelah putaran pembelian terakhir berakhir",
  LText: "Dibuka setiap hari selama periode jaminan harga",
  WText: "Dibuka setiap hari di luar periode jaminan harga",
  unlockend: "Telah Dibuka",
  record: "Detail Pembelian",
  myPurchaseName: "Proyek Yang Saya Ikuti",
};

//mHeader
const mHeader = {
  sy: "Beranda",
  ksjy: "Perdagangan Cepat",
  zyjy: "Perdagangan Profesional",
  c2c: "Perdagangan C2C",
  otc: "Perdagangan OTC",
  zczx: "Pusat Aset",
  xwgg: "Berita & Pengumuman",
  xwgg1: "Pengumuman",
  lc: "BiKing Earn",
  gxlc: "Simpanan Bunga Tinggi",
  dxjh: "FansUp!",
  fbjy: "Beli Koin",
  dl: "Login",
  zc: "Daftar",
  jtzw: "Bahasa Tionghoa Sederhana",
  ftzw: "Bahasa Tionghoa Tradisional",
  english: "English",
  kr: "한국어",
  qgms: "Pembelian Kilat",
  xsjy: "Perdagangan Potensial",
  // 剩下的国际化
  zczgz: "Total Perkiraan Aset",
  yhzx: "Pusat Pengguna",
  wdgl: "Manajemen Order",
  tc: "Keluar Akun",
  dltq: "Zona Likuiditas Rendah",
  sdgm: "Pembelian Kilat",

  // app down
  appdown: "Unduh APP",
  appdown1: "Unduh",
  biking: "BiKing APP",
  gfqb: "Dompet Resmi",
  xzbyapp: "Unduh BiKing APP",
  xzbyapp2: "Unduh BiKing APP",
  smewm: "Pindai Kode QR",
  xzhyqb: "Unduh Dompet HyperPay",
  xzhyqb2: "Unduh Dompet HyperPay",
  bbjy: "Perdagangan Spot",
  hyjy: "Kontrak Abadi", //"合约交易",
  eftjy: "Perdagangan ETF",
  byb: "Earn",
  newPos: "Kolam HBT",
  HyperPay: "Earn HyperPay",
  hqlc: "POS Mining",
  newlc: "Earn",

  // 新header
  dd: "Pesanan",
  zichan: "Aset",
  xxzx: "Pusat Pesan",
  zhyaq: "Akun & Keamanan",
  sfyz: "Verifikasi Identitas",
  wdvip: "VIP Saya",
  apigl: "Manajemen API",
  hdzx: "Pusat Aktivitas",
  wdhb: "Amplop Saya",
  flzx: "Pusat Bonus",
  bitloan: "Pinjaman Koin",
  ggjy: "Perdagangan Margin",
  hyxy: "Akademi",
  flhd: "Aktivitas Bonus",
  bitWin: "BiKing Treasure",
};
//progress
const mProgress = {
  dqjd: "Progress Saat Ini",
  yjs: "Telah Dibuka",
};

//res
const res = {
  //抢购错误提示
  seckill_project_000: "Sistem Abnormal",
  seckill_project_001: "Tidak Ada Proyek Tersedia",
  seckill_project_002: "Informasi Proyek Tidak Ada",
  // 用户信息错误提示
  seckill_userInfo_001: "Pengguna Tidak Ada",
  //i18n错误提示
  i18n_no_table_001: "Sistem Sibuk",
  //抢购记录
  seckill_record_1: "Pembayaran Gagal",
  //7日持仓规则
  seckill_7days_1: "Di bawah proyek saat ini, aturan holding tidak ditemukan",
  //钱包相关
  seckill_wallet_1: "Sistem Sibuk",
  seckill_wallet_2: "Saldo Dompet Tidak Cukup",
  seckill_wallet_3: "Pembayaran Gagal",
  //项目统计
  seckill_record_count_1: "Data Error",
  seckill_record_count_2: "Pembayaran Gagal",
  seckill_record_count_3: "Pembayaran Gagal",
  //项目轮次
  seckill_rounds_1: "Sistem Sibuk",
  seckill_rounds_2: "Dalam proyek saat ini, tidak ditemukan putaran yang sedang dalam pembelian",
  seckill_rounds_3: "Dalam proyek saat ini, informasi putaran tidak ditemukan",
  seckill_rounds_4: "Sistem Sibuk",
  seckill_rounds_5: "Dalam proyek saat ini, informasi putaran yang ditentukan tidak ditemukan",
  //项目信息
  seckill_pro_1: "Informasi Proyek Tidak Ditemukan",
  seckill_pro_2: "Kuota pembelian kurang dari jumlah pembelian minimum",
  seckill_pro_4: "Sistem Sibuk",
  seckill_pro_5: "Proyek dalam Status Non-Daftar",
  //支付
  seckill_pay_1: "Sistem Sibuk",
  seckill_pay_2: "Sistem Sibuk",
  seckill_pay_3: "Informasi Proyek Tidak Ditemukan",
  seckill_pay_4: "Kuota pembelian kurang dari jumlah pembelian minimum",
  seckill_pay_5: "Kuota pembelian melebihi kuota sisa putaran ini",
  seckill_pay_6: "Tidak Ada Kuota Pembelian",
  seckill_pay_7: "Jumlah pembelian lebih besar dari kuota pembelian",
  seckill_pay_8: "Sistem Sibuk",
  seckill_pay_9: "Kata Sandi Transaksi Salah",
  seckill_pay_10: "Pembayaran Gagal, silakan beli lagi",
  seckill_pay_11: "Pembayaran Gagal, silakan beli lagi",
  seckill_pay_12: "Informasi Pengguna Salah",
  seckill_pay_13: "Pembayaran Gagal",
  seckill_pay_14: "Kata Sandi Transaksi Salah",
  seckill_pay_15: "Sistem Sibuk",
  seckill_pay_16: "Telah Habis",
  seckill_pay_17: "Maaf, terlalu banyak orang mengantri untuk membeli, silakan coba lagi",
  seckill_pay_18: "Telah Dibeli di Putaran Ini",
  seckill_pay_19: "Putaran Ini Telah Habis",
  seckill_pay_20: "Silakan Login Terlebih Dahulu",
  seckill_pay_21: "Silakan Selesaikan Verifikasi Identitas Terlebih Dahulu",
  seckill_pay_22: "Proyek ini hanya untuk pengguna KYC Tiongkok Daratan",
  seckill_pay_23: "Proyek ini hanya untuk pengguna KYC di Luar Tiongkok Daratan",
  seckill_pay_24: "Kesalahan kata sandi transaksi melebihi batas, silakan coba lagi nanti",
  seckill_hold_1: "Jumlah [*] yang Anda pegang tidak memenuhi syarat partisipasi, silakan beli terlebih dahulu sebelum berpartisipasi",
  // 问卷调查
  seckill_survey_submited: "Anda telah mengirimkan kuesioner ini",
  seckill_survey_error: "Kesalahan Pemrosesan Informasi Kuesioner",
  seckill_survey_info: "Di bawah proyek saat ini, informasi kuesioner ini tidak ditemukan",
};

const addContent = {
  hdjshy: 'Sisa waktu menuju akhir aktivitas',
  qgsj: "Waktu Pembelian",
  qgsjNew: "Waktu Bantuan",
  gz: "Aturan",
  zdjg: "Harga Terendah",
  sq: "Tutup",
  qgms: "Pembelian Kilat",
  rgxm: "Proyek Yang Diikuti",
  bled: "Kuota Putaran Ini",
  dqjd: "Progress Saat Ini",
  yjs: "Telah Dibuka",
  yff: "Telah Didistribusikan",
  qbcc: "Pertahankan Holding",
  cg: "Melebihi",
  jxmks: "Sisa Waktu Menuju Mulai Proyek",
  ycgrg: "Telah Berhasil Membeli",
  cgrg: "Berhasil Membeli",
  xmed: "Kuota Proyek",
  cxmck: "Kuota Penggalangan Dana Proyek Ini",
  ckmb: "Penggalangan Dana Aktual Mencapai Target Penggalangan Dana",
  ck: "Penggalangan Dana",
  ckxq: "Lihat Detail",
  kqed: "Kuota yang Dapat Dibeli",
  zhcc: "Holding Akun",
  jjks: "Pembelian Segera Dimulai",
  mmsz: "Selesaikan Pengaturan Kata Sandi Transaksi Akun",
  qsz: "Atur",
  qbye: "Pastikan saldo [*] di akun lebih dari [**]",
  zjcz: "Pastikan holding lebih dari [*] [**] (jumlah pembelian minimum)",
  jgdb: "Jaminan Harga, Tidak Akan Jatuh",
  jgyh: "Rebate VIP, Harga Diskon",
  bwbj: "Perlindungan Harga Eksklusif Berbasis Fiat",
  bj: "Jaminan Harga [*] Hari, Tidak Akan Jatuh",
  sybj: "Pendapatan [*]%, Janji Jaminan Harga",
  zk: "Diskon VIP, Beli dan Untung",
  r: "Orang",
  lsxm: "Proyek Sejarah",
  // bpf: "15天不破发，能上不能下",
  bpf: "Dukungan Komunitas, Gelombang Hadiah Besar Tiba",
  // syybz: "收益有保障，发行有让利",
  syybz: "Partisipasi Berthreshold Rendah, Nikmati Hadiah Bersama",
  // hg: "回馈VIP，抢购大折扣",
  hg: "Menjadi Member VIP, Nikmati Lebih Banyak Keuntungan",
  zgkx: "Diskon Maksimum [*] [**]",
  vip_zgkx: "Semakin tinggi level VIP, semakin besar diskon total harga pembelian. VIP6 tertinggi dapat menikmati diskon [*][**]",
  vip_zgkxNew: "Semakin tinggi level VIP, semakin besar diskon total bantuan. VIP6 tertinggi dapat menikmati diskon [*][**]",
  blsysj: "Sisa Waktu Putaran Ini",
  blqbqw: "Putaran Ini Telah Habis",
  xyl: "Putaran Berikutnya",
  zskq: "Mulai Tepat Waktu",
  bljshs: "Sisa Waktu Menuju Akhir Putaran",
  zqyc: "Hanya dapat membeli sekali per putaran, silakan datang lagi di putaran berikutnya!",
  zxkf: "Anda tidak memiliki izin untuk berpartisipasi dalam aktivitas ini, silakan hubungi layanan pelanggan untuk detailnya",
  zqycNew: "Hanya dapat membantu sekali per putaran, silakan datang lagi di putaran berikutnya!",
  wed: "Kuota yang dapat Anda beli untuk proyek ini adalah 0, silakan perhatikan proyek berikutnya",
  wedNew: "Kuota yang dapat Anda bantu untuk proyek ini adalah 0, silakan perhatikan proyek berikutnya",
  zsqg: "Kuota pembelian minimum [*][**], silakan beli lagi setelah menambah holding",
  srmm: "Masukkan Kata Sandi Transaksi",
  smrz: "Silakan Selesaikan Verifikasi Identitas KYC Terlebih Dahulu",
  qszjymm: "Silakan Atur Kata Sandi Transaksi Terlebih Dahulu",
  wenjuandiaocha: "Anda perlu menyelesaikan kuesioner terlebih dahulu sebelum dapat berpartisipasi dalam aktivitas ini.",
  scqgms: "Pesta Penggemar BiKing",
  // scqgms: "首创保价模式",
  // hxyh: "限时保底收益，VIP更多让利",
  hxyh: "Dukung Komunitas BiKing, Nikmati Beragam Hadiah",
  zsqged: "Kuota Pembelian Minimum [*] [**]",
  zsqgedNew: "Kuota Bantuan Minimum [*] [**]",
  wmtj: "Jumlah [**] yang Anda pegang tidak memenuhi syarat partisipasi, silakan beli terlebih dahulu sebelum berpartisipasi",
  qjchqg: "Silakan beli lagi setelah menambah holding",
  qjchqgNew: "Silakan beli lagi setelah menambah holding untuk membantu",
  rgjg: "Harga Pembelian",
  qqg: "Beli Diskon",
  wdqgjl: "Catatan Partisipasi Saya",
  ckxmxq: "Lihat Detail Proyek",
  t: "Hari",
  yr: "[*]月[**]日",
  yrz: "Putaran ke-[*] Pemanasan",
  qgz: "Putaran ke-[*] Sedang Dibeli",
  djlyjs: "Putaran ke-[*] Telah Berakhir",
  dj: "Level VIP",
  xszk: "Rasio Diskon",
  jgzked: "Kuota Diskon Partisipasi",
  zked: "Kuota Diskon",
  edw: "Pembayaran normal untuk jumlah di luar kuota",
  qbcczd: "Pastikan holding lebih dari 1000CWT (jumlah pembelian minimum)",
  qrrjcc: "Rata-rata Holding 7 Hari",
  jlblks: "Menuju Mulai Putaran Ini",
  jlbljs: "Menuju Akhir Putaran Ini",
  zgkqed: "Kuota Pembelian Maksimum",
  zgkzf: "Pembayaran Maksimum",
  cggmsl: "Jumlah pembelian yang Anda isi melebihi batas pembelian Anda",
  bzzfzxgm: "Holding saat ini tidak cukup untuk pembelian minimum",
  bqzdqg: "Kuota pembelian minimum adalah [*] [**]",
  zlzcLower: "Kuota bantuan minimum adalah [*], maksimum [**]. Token yang diperoleh dari bantuan akan didistribusikan ke akun Anda dalam 5 hari kerja setelah aktivitas berakhir.",
  zgqged: "Kuota Maksimum adalah [*] [**]",
  yzbz: "Diskon Eksklusif Penggemar untuk Mata Uang Berkualitas Terbatas Waktu",
  xszkj: "Harga Diskon Terbatas Waktu",
  zlbxsq: "Pembelian Kilat Mata Uang Utama Terbatas Waktu",
  wks: "Belum Dimulai",
  jxz: "Sedang Berlangsung",
  qgsl: "Jumlah Pembelian",
  wcydxm: "Proyek Yang Saya Ikuti",
  bjq: "Periode Penawaran",
  hgq: "Periode Buyback",
  qzk: "Beli Diskon",
  qxzl: "Bantu Duluan Menang Token",
  ds: "Batas Bantuan",
  dhbl: "Rasio Konversi",
  jicj: "Harga Dasar",
  jiagzd: "Harga akhir ditentukan dalam 3 jam sebelum pembelian dimulai",
  zdyh: "Keuntungan Maksimum",
};

const hyy = {
  bkt: "Tidak Buka",
  wqdkt: "Saya Yakin Buka",
  kt12: "1. Sebelum berpartisipasi, Anda harus memahami secara menyeluruh pengetahuan dasar dan risiko terkait perdagangan kontrak mata uang digital serta semua aturan bisnis terkait yang terkait dengan partisipasi dalam perdagangan derivatif.",
  kt13: "2. Pemberitahuan risiko di atas hanya bersifat enumeratif dan tidak mencantumkan secara lengkap semua faktor risiko yang terkait dengan perdagangan derivatif aset digital. Sebelum berinvestasi dalam perdagangan derivatif aset digital, investor harus memahami dan menguasai faktor risiko lain yang mungkin ada.",
  kt14: "3. Kami dengan tulus berharap dan menyarankan investor, berdasarkan kemampuan menanggung risiko dan kondisi aktual mereka sendiri, untuk memutuskan dengan hati-hati apakah akan berpartisipasi dalam perdagangan kontrak ini, dan mengalokasikan aset digital mereka secara wajar.",
  kt0: "Pengguna Terkasih:",
  kt1: "Anda belum membuka akun kontrak dan izin perdagangan kontrak, silakan baca dengan cermat konten berikut sebelum memutuskan untuk membuka:",
  kt2: "1. Saat Anda melakukan perdagangan di pasar kontrak, jika pergerakan harga pasar tidak menguntungkan Anda dan menyebabkan margin posisi Anda tidak mencukupi, BiKing Kontrak Abadi akan melakukan likuidasi posisi Anda sesuai dengan kesepakatan sistem dan mengungkapkan detail likuidasi.",
  kt3: "2. Anda harus membaca dan mematuhi aturan bisnis BiKing Kontrak Abadi, memahami mekanisme dan prinsip operasi kontrak, dan memahami berbagai risiko pasar.",
  kt4: "4. BiKing Kontrak Abadi terhubung ke sistem perdagangan kontrak, keuntungan dan kerugian posisi pengguna berfluktuasi dengan fluktuasi pasar kontrak. Ketika kerugian besar, likuidasi juga dapat terjadi dalam sistem perdagangan kontrak. Silakan pengguna memutuskan perilaku perdagangan mereka sendiri berdasarkan pasar kontrak, menanggung keuntungan dan kerugian sendiri. Dengan demikian, BiKing tidak bertanggung jawab atas segala jaminan yang disiratkan atau ditetapkan.",
  kt5: "5. Dalam kondisi pasar tertentu yang ekstrem, Anda mungkin mengalami kesulitan atau tidak dapat menutup posisi terbuka yang Anda pegang. Misalnya, ketika keuntungan Anda menempati peringkat pertama dalam PnL leverage efektif seluruh pasar kontrak, dan pihak lawan memiliki dana asuransi yang tidak cukup untuk menutupi kerugian insolvensi mereka.",
  kt6: "6. Perdagangan derivatif aset digital mungkin menghadapi risiko pengawasan kebijakan dalam yurisdiksi tertentu. Sebelum melakukan perdagangan, Anda perlu membuat penilaian dengan hati-hati dengan memahami latar belakang pengawasan kebijakan wilayah perdagangan. Karena perubahan hukum, peraturan, kebijakan di negara dan wilayah terkait, modifikasi aturan perdagangan bursa kontrak, penerapan tindakan darurat, dll., BiKing akan mengungkapkan pernyataan sebelumnya. Posisi terbuka yang Anda pegang mungkin tidak dapat dipertahankan, tetapi saldo margin dan keuntungan masih akan direalisasikan.",
  kt7: "7. Karena alasan di luar kendali platform, seperti force majeure (gempa bumi, banjir, kebakaran, dll.) atau kegagalan sistem komputer, sistem komunikasi, dll., perintah Anda mungkin tidak dapat dieksekusi atau dieksekusi seluruhnya, dan kerugian yang diakibatkannya mungkin harus ditanggung sendiri.",
  kt8: "8. Perdagangan \"Lindung Nilai\" menghadapi risiko yang sama dengan perdagangan spekulatif, yaitu risiko yang ditimbulkan oleh fluktuasi harga.",
  kta9: "9. Jika Anda tidak melakukan verifikasi identitas atau tidak mengikat verifikasi Google, atau meminjamkan akun kepada orang lain untuk dioperasikan, hal ini dapat memengaruhi keamanan margin kontrak Anda.",
  kta10: "3. Dalam kondisi pasar tertentu yang ekstrem, Anda mungkin mengalami kesulitan atau tidak dapat menutup posisi terbuka yang Anda pegang. Misalnya, ketika keuntungan Anda menempati peringkat pertama dalam PnL leverage efektif seluruh pasar kontrak, dan pihak lawan memiliki dana asuransi yang tidak cukup untuk menutupi kerugian insolvensi mereka.",
  kt9: "Saya telah membaca dengan cermat dan bersedia menanggung risiko",
  kt10: "Buka Akun Kontrak dan Izin Perdagangan Kontrak",
  zjhz: "Transfer Dana",
  ljhz: "Transfer Sekarang",
  qx: "Batalkan Transfer",
  khz: "Dapat Ditransfer",
  qxz: "Silakan Pilih",
  bz: "Mata Uang",
  c: "Dari",
  zz: "Ke",
  sl: "Jumlah",
  qb: "Semua",
  ktcg: "Pembukaan Berhasil",
  ktsb: "Pembukaan Gagal",
  hzcg: "Transfer Berhasil",
  hzsb: "Transfer Gagal",
  wyyd: "", //未勾选已经阅读提示文案
  tc: "Keluar",
  warning1: "Silakan Pilih Mata Uang",
  warning2: "Akun Sumber Tidak Boleh Kosong",
  warning3: "Akun Tujuan Tidak Boleh Kosong",
  warning4: "Masukkan angka yang tidak lebih besar dari jumlah yang dapat ditransfer",
  gb: "Tutup",
  openSuccess: "Anda Telah Membuka Perdagangan Kontrak",
  openSuccessTip: "Silakan transfer dana ke akun kontrak",
  warning5: "Maksimal 4 desimal",
  not_get_nm: "Maaf, aktivitas泥码telah berakhir, transfer ini tidak mendapatkan泥码",
};

const trading = {
  gflj: 'Tautan Resmi',
  gw: 'Situs Web',
  qkllq: 'Penjelajah Blok',
  scfxsj: 'Waktu Penerbitan Pertama',
  fxzl: 'Total Penerbitan',
  ltzl: 'Total Sirkulasi',
  jy: 'Perdagangan',
  sj: 'Harga Pasar',
  tbxx: 'Informasi Grafik',
  bzgk: 'Gambaran Umum Mata Uang',
  ddb: 'Buku Order',
  zxcj: 'Transaksi Terbaru',

  reload: "Muat Ulang",
  socketError: "Kesalahan Jaringan, Silakan",
  noData: "Belum Ada Data",
  entrustorder: "Order Buku",
  prices: "Harga",
  quantity: "Jumlah",
  grandtotal: "Akumulasi",
  transamount: "Jumlah Transaksi",
  time: "Waktu",
  available: "Tersedia",
  limitorder: "Limit",
  plancommission: "Order Rencana",
  currentcommission: "Order",
  historycommission: "Order Sejarah",
  completecommission: "Order Selesai",
  funds: 'Dana',
  hidetrading: "Sembunyikan Pasangan Lain",
  morecurrentcommission: "Order Saat Ini Lainnya",
  morehistorycommission: "Order Sejarah Lainnya",
  moredocommission: "Order Selesai Lainnya",
  realtimetrans: "Transaksi Real-time",
  myassets: "Aset Saya",
  detail: "Detail",
  buyin: "Beli",
  sellout: "Jual",
  login: "Login",
  transfer: "Transfer",
  recharge: "Isi Ulang",
  withdrawal: "Beli Koin",
  quickpurchase: "Pembelian Cepat Fiat",
  default: "Default",
  ordertime: "Waktu Order",
  tradingpair: "Pasangan Dagang",
  direction: "Arah",
  types: "Jenis",
  commissionprice: "Harga Order",
  commissionnumber: "Jumlah Order",
  dealprice: "Harga Rata-rata Eksekusi",
  dealnumber: "Jumlah Eksekusi",
  triggerprice: "Harga Pemicu",
  cancelall: "Batalkan Semua",
  averageprice: "Harga Rata-rata",
  totalsum: "Total",
  fixedprice: "Limit",
  marketprice: "Harga Pasar",
  codeExpired: "Kode QR Kedaluwarsa",
  clickRefresh: "Klik untuk Muat Ulang",
  QRsuccessfully: "Pemindaian Berhasil",
  loginInApp: "Silakan konfirmasi login di APP",
  backtoQR: "Kembali ke Login Kode QR",
  loginSuccess: "Anda telah berhasil login, selamat datang di biking!",
  loadingText: "Memuat...",
  searchPlaceholder: "Cari",
  all: "Semua",
  currency: "Mata Uang",
  price: "Harga Terbaru",
  market: "Papan Kenaikan",
  increase: "Kenaikan",
  highestPrice: "Tertinggi",
  minimumPrice: "Terendah",
  turnover: "Volume",
  jydlb: "Daftar Pasangan Dagang",
  bzjs: "Pengenalan Mata Uang",
  currencyTransaction: "Perdagangan Spot",
  leveragedTransaction: "Perdagangan Margin",
  warning: "Peringatan Risiko: Bitcoin Cash fork memiliki ketidakpastian yang sangat besar. Perdagangan atau investasi dalam token futures fork memiliki risiko sangat besar. Jika suatu chain kekurangan dukungan penambang, kemungkinan besar tidak akan bertahan, dan token terkait yang dipegang berisiko menjadi nol. BiKing tidak membuat janji apa pun mengenai nilai token futures fork!",
  zb: "Indikator",
  date: "Waktu",
  UpAnddown: "Naik/Turun",
  amplitude: "Amplitudo",
  0: "Per Menit",
  1: "1 Menit",
  5: "5 Menit",
  15: "15 Menit",
  30: "30 Menit",
  60: "1 Jam",
  240: "4 Jam",
  3600: "1 Hari",
  10800: "1 Minggu",
  dates: "Periode：",
  password: "Kata Sandi Transaksi",
  errorPassword: "Silakan masukkan kata sandi transaksi yang benar",
  worningPassword: "Silakan masukkan kata sandi transaksi",
  cancel: "Batal",
  sure: "OK",
  canBuy: "Dapat Dibeli",
  canCell: "Dapat Dijual",
  withdraw: "Tarik Koin",
  otc: "OTC, masuk cepat dan penarikan fiat",
  enterPrice: "Masukkan Harga",
  sellingPrice: "Harga Jual",
  purchasePrice: "Harga Beli",
  salesVolume: "Volume Jual",
  buyingVolume: "Volume Beli",
  volume: "Jumlah Transaksi",
  serviceCharge: "Biaya Layanan",
  vip: "Upgrade VIP, nikmati diskon biaya layanan",
  or: "Atau",
  register: "Daftar",
  totalPrice: "Jumlah transaksi tidak boleh lebih besar dari",
  amountTip: "Silakan masukkan jumlah yang benar",
  amountTipError: "Jumlah tidak boleh lebih besar dari",
  limitTrading: "Perdagangan Limit",
  priceReminder: "Pengingat Harga",
  SMSReminder: "Pengingat SMS",
  loginAccount: "Login Akun",
  phone: "Telepon",
  phoneNum: "Masukkan Nomor Telepon",
  phoneTips: "Masukkan nomor telepon yang benar",
  email: "Email",
  emailNum: "Masukkan Email",
  emailTips: "﻿Masukkan email yang benar",
  aears: "Silakan Pilih Kode Area",
  passwordError: "Silakan masukkan kata sandi yang benar",
  passwordTips: "Silakan masukkan kata sandi",
  forgetPassword: "Lupa Kata Sandi",
  noAccount: "Tidak Ada Akun",
  goRegister: "Daftar Sekarang",
  appsys: "Pindai Kode QR APP untuk Login Aman",
  xzapp: "Unduh APP Terbaru",
  mmdl: "Login Kata Sandi",
  smdl: "Login Pindai",
  google: "Google Authenticator",
  nybd: "Anda Telah Mengikat",
  zqyzm: "Masukkan Kode Verifikasi yang Benar",
  fsyzm: "Kirim Kode Verifikasi",
  flv: "Tingkat Biaya",
  jz: "Nilai Bersih",
  jzdesc1: "Nilai bersih Long = nilai bersih pada titik penyesuaian sebelumnya * [1+3*(harga eksekusi terbaru spot - harga spot pada titik penyesuaian sebelumnya)/harga spot pada titik penyesuaian sebelumnya*100%];",
  jzdesc2: "Nilai bersih Short = nilai bersih pada titik penyesuaian sebelumnya * [1-3*(harga eksekusi terbaru spot - harga spot pada titik penyesuaian sebelumnya)/harga spot pada titik penyesuaian sebelumnya*100%];",
  sbd: "3x Long",
  sbs: "3x Short",
  flvjs: "Tingkat biaya dana ETF adalah biaya manajemen yang dikenakan platform setiap hari untuk leverage, digunakan untuk membayar tingkat biaya dana yang dihasilkan oleh kombinasi dana. Biaya manajemen akan tercermin dalam perubahan nilai bersih, yaitu dengan cara 'mengurangi nilai leverage ETF yang sesuai', dan hanya akan dikenakan pada pukul 0 waktu Singapura. Jika Anda tidak memegang produk pada waktu tersebut, tidak akan ada biaya.",
  mzsm: "Pernyataan Penolakan",
  ido: "Saya telah membaca dan menyetujui",
  exemption1: "Pelanggan yang terhormat, halo!",
  exemption2: "Terima kasih telah login dan menggunakan produk ETF dan layanan terkait yang disediakan oleh platform BiKing (BiKing.ai) (selanjutnya disebut sebagai \"Produk ETF\"). Silakan baca dengan cermat penjelasan produk ETF dan peringatan risiko berikut. Setelah membaca, jika Anda terus menggunakan produk ETF, itu berarti Anda sepenuhnya memahami dan memahami risiko produk ETF, mampu menanggung kerugian yang mungkin ditimbulkan oleh penggunaan produk ETF, dan dianggap setuju dengan semua isi pernyataan penolakan ini. Silakan klik untuk membaca penjelasan produk ETF:",
  exemption3: "《FAQ Produk Leverage ETF》",
  exemption4: "Peringatan Risiko:",
  exemption5: "1. Harga beli/penjualan Anda tidak boleh menyimpang terlalu jauh dari nilai bersih per unit, jika tidak Anda akan menderita kerugian yang sesuai.",
  exemption6: "2. Jika penilaian arah salah, dalam kondisi pasar yang ekstrem, ada risiko harga mendekati nol.",
  exemption7: "Platform BiKing dengan ini dengan sungguh-sungguh mengingatkan Anda bahwa kerugian atau tanggung jawab yang diakibatkan oleh risiko di atas akan ditanggung sendiri oleh Anda, dan platform BiKing tidak bertanggung jawab atas hal ini. Pernyataan penolakan ini, bersama dengan perjanjian, pernyataan, aturan, dll. lainnya di dalam platform BiKing, membentuk kesepakatan lengkap antara platform BiKing dan Anda mengenai layanan dan produk platform BiKing.",
  bzjs1: "1、“3L” menunjukkan bahwa jika harga pasangan underlying naik 1%, nilai bersih produk ini naik 3%",
  bzjs2: "2、“3S” menunjukkan bahwa jika harga pasangan underlying turun 1%, nilai bersih produk ini naik 3%",
  bzjs3: "3、Nilai bersih biasanya disesuaikan setiap hari pada pukul 0, dan akan disesuaikan selama sesi dalam kondisi pasar yang ekstrem",
  bzjs4: "4、Setiap kali leverage akan dikenakan biaya manajemen harian yang sesuai",
  bzjs5: "5、Sebelum melakukan transaksi, harap perhatikan nilai bersih. Produk ini dalam kondisi pasar yang ekstrem berisiko harga mendekati nol, harga sangat menyimpang dari nilai bersih, harap investor memperhatikan kontrol risiko",
  gdjk: "Untuk detail lebih lanjut, silakan lihat pengumuman",
  firstTrading: "Sebelum melakukan transaksi pertama, silakan atur kata sandi transaksi",
  status: "Status",
  status1: "Menunggu Eksekusi",
  status2: "Belum Dieksekusi",
  status3: "Dibatalkan Pengguna",
  status4: "Sebagian Dieksekusi",
  status5: "Sepenuhnya Dieksekusi",
  status6: "Tidak Valid",
  allCancel: "Batalkan Semua Order Secara Massal",
  canceld: "Batalkan Order",
  cancelsuccess: "Semua pembatalan order berhasil, [*] order telah dibatalkan",
  VIP1: "Level Anda VIP",
  VIP2: "Biaya transaksi yang lebih rendah, pengalaman perdagangan yang lebih baik",
  VIP3: "Taker(吃单)：",
  VIP4: "Maker(挂单)：",
  buyAmount: "Jumlah pembelian tidak boleh lebih tinggi dari",
  sellAmount: "Jumlah penjualan tidak boleh lebih tinggi dari",
  buyAmountMin: "Saldo yang dapat dibeli tidak mencukupi",
  sellAmountMin: "Saldo yang dapat dijual tidak mencukupi",
};

const common = {
  wan: "Ribu",
  qian: "Ribu", // Note: 'qian' is also thousand, often used in financial context for 1,000. 'Wan' is 10,000.
  yi: "Miliar", // 100 Million
};
const transferDialog = {
  划转: "Transfer",
  资金互转: "Transfer Dana Timbal Balik",
  币币账户: "Akun Spot",
  买币账户: "Akun Beli Koin",
  已冻结: "Telah Dibekukan",
  合约账户: "Akun Kontrak",
  未开通: "Belum Dibuka",
  杠杆账户: "Akun Margin",
  币贷宝账户: "Akun Pinjaman Koin",
  从: "Dari",
  转至: "Ke",
  币种: "Mata Uang",
  数量: "Jumlah",
  全部: "Semua",
  用户未归还借贷的情况下: "Dalam hal pengguna belum mengembalikan pinjaman, dana dengan rasio risiko lebih besar dari 200% dapat ditransfer keluar",
  可划转: "Dapat Ditransfer",
  一阶: "1、Tahap Satu",
  累计净划入: "Akumulasi Transfer Bersih Masuk",
  可获得: "Dapat Memperoleh",
  泥码: "泥码", //泥码 is often a platform-specific term, kept as is.
  二阶: "2、Tahap Dua",
  您尚未完成实名认证: "Anda Belum Menyelesaikan Verifikasi Identitas",
  余额: "Saldo",
  立即划转: "Transfer Sekarang",
  资产划转: "Transfer Aset",
  用于维持现有仓位的保证金: "Margin digunakan untuk mempertahankan posisi yang ada",
  归还数量: "Jumlah Pengembalian",
  您的币贷宝账户尚未开通: "Akun Pinjaman Koin Anda belum dibuka, silakan buka terlebih dahulu",
  请输入正确的数量: "Silakan masukkan jumlah yang benar",
  划转金额不能为: "Jumlah transfer tidak boleh 0",
  账户可用余额不足: "Saldo akun yang tersedia tidak mencukupi",
  划转失败: "Transfer Gagal",
  划转成功: "Transfer Berhasil",
  本次划转未能获得泥码: "Maaf, aktivitas泥码telah berakhir, transfer ini tidak mendapatkan泥码",
  您只需再向合约账户划转: "Anda hanya perlu mentransfer [*] USDT lagi ke akun kontrak untuk mendapatkan [**] USDT泥码",
  您向合约账户: "Anda mentransfer bersih kumulatif [*]USDT atau lebih ke akun kontrak, dapatkan", // <br/> handled in code logic
  请输入划转数量: "Silakan masukkan jumlah transfer",
};
export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
};


// WEBPACK FOOTER //
// ./src/i18n/lang/ba.js